export default {
  renderNode: {
    'embedded-asset-block': ({ data: { target: { fields } } }) =>
      `<img src="${fields.file.url}" height="${fields.file.details.image.height}" width="${fields.file.details.image.width}" alt="${fields.description}"/>`,
  },
}
